import { Box, Chip, Stack, Typography } from '@mui/material';
import AiIcon from '@product-framework/components/ArtificalIntelligence/AiIcon';
import DispatchEventStatus from '@product-framework/components/DispatchEventStatus';
import { IconChip } from '@product-framework/components/PageSection';
import { IconLibrary } from '@product-framework/index';
import { TypewriterText, useLocalization } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';

function DispatchInfo({ location, sp }) {
  const { formatMessage } = useLocalization();
  const dispatchSentToThisLocation =
    location?.id === sp?.metadata?.dispatchedLocationId;

  const notReceivedDispatchReasons = () => {
    const reasons = [];
    if (location?.dispatchAcceptanceStatus === 'INITIAL_DISPATCHED_LOCATION') {
      reasons.push(
        formatMessage({
          id: 'INITAL_DISPATCH_MESSAGE',
          defaultMessage:
            'This location got the initial dispatch but job was accepted/assigned to different location.',
        }),
      );
    } else {
      if (sp?.status !== 'ACTIVE') {
        reasons.push(
          formatMessage({
            id: 'NO_DISPATCH_INACTIVE_SP',
            defaultMessage: 'Service provider status is inactive.',
          }),
        );
      }
      if (sp?.compliant !== true) {
        reasons.push(
          formatMessage({
            id: 'NO_DISPATCH_NON_COMPLIANT_SP',
            defaultMessage: 'Service provider is non-compliant.',
          }),
        );
      }
      if (sp?.dispatchMethod === 'MANUAL') {
        reasons.push(
          formatMessage({
            id: 'NO_DISPATCH_MANUAL_DISPATCH_SP',
            defaultMessage: 'Service provider dispatch method is manual.',
          }),
        );
      }

      if (!location?.skills?.servicesIndustry) {
        reasons.push(
          formatMessage({
            id: 'NO_DISPATCH_SKILL_INDUSTRY_SP',
            defaultMessage: 'Service provider does not service the industry.',
          }),
        );
      }
      if (!location?.skills?.servicesProductLine) {
        reasons.push(
          formatMessage({
            id: 'NO_DISPATCH_SKILL_PRODUCT_SP',
            defaultMessage: 'Service provider does not service the product.',
          }),
        );
      }
      if (!location?.skills?.servicesBrand) {
        reasons.push(
          formatMessage({
            id: 'NO_DISPATCH_SKILL_BRAND_SP',
            defaultMessage: 'Service provider does not service the brand',
          }),
        );
      }

      if (!location?.skills?.withinTravelDistance) {
        reasons.push(
          formatMessage({
            id: 'NO_DISPATCH_SKILL_BRAND_SP',
            defaultMessage: 'Job is outside service providers travel distance',
          }),
        );
      }
    }
    return reasons;
  };

  const reasons = notReceivedDispatchReasons();

  return (
    <Box>
      <Stack
        direction="row"
        spacing={1}
        sx={{ justifyContent: 'space-between' }}>
        {dispatchSentToThisLocation ? (
          <Stack
            direction="row"
            spacing={0.5}
            sx={{ alignItems: 'center', justifyContent: 'left' }}>
            <IconChip
              bgColor="success.main"
              iconColor="white"
              Icon={IconLibrary.Dispatch}
              size={22}
              iconFontSize="12px"
            />
            <Typography color="success" fontWeight="bold">
              <FormattedMessage
                id="DISPATCH_SENT"
                defaultMessage="Received Dispatch"
              />
            </Typography>
          </Stack>
        ) : (
          <Stack
            direction="row"
            spacing={0.5}
            sx={{ alignItems: 'center', justifyContent: 'left' }}>
            <IconChip
              bgColor="error.main"
              iconColor="white"
              Icon={IconLibrary.DispatchNotSent}
              size={25}
              iconFontSize="15px"
            />
            <Typography variant="body1" fontWeight={500} color="error.main">
              <FormattedMessage
                id="DISPATCH_NOT_SENT"
                defaultMessage="Did Not Receive Dispatch Request"
              />
            </Typography>
          </Stack>
        )}
        {location?.dispatchAcceptanceStatus && (
          <Chip
            variant="outlined"
            sx={{ borderRadius: 0 }}
            label={
              <DispatchEventStatus
                showAsTextProps={{ sx: { fontWeight: 500 } }}
                showAsText
                value={location?.dispatchAcceptanceStatus}
              />
            }
          />
        )}
      </Stack>
      {reasons?.length > 0 && (
        <Box sx={{ mt: 1 }}>
          <Stack direction="row" spacing={0.5}>
            <AiIcon sx={{ fontSize: '18px', pt: '4px' }} />
            <Box>
              {reasons?.map(reason => {
                return (
                  <Typography
                    key={reason}
                    variant="caption"
                    component="p"
                    color="text.secondary"
                    sx={{ lineHeight: '1.5em' }}>
                    <TypewriterText text={reason} />
                  </Typography>
                );
              })}
            </Box>
          </Stack>
        </Box>
      )}
    </Box>
  );
}

export default DispatchInfo;
